<!-- eslint-disable prettier/prettier -->
<ng-container *transloco="let t">
  <a
    *ngIf="(sharedImages$ | async) || mockData as images"
    [routerLink]="urlFragments"
    [queryParams]="queryParameters"
    class="category-item"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <span class="pic-wrapper flex popsy-card">
      <img
        *ngIf="product?.category === 'SMARTPHONE'"
        class="picture"
        [alt]="product?.model"
        [src]="images.phone" />
      <img
        *ngIf="product?.category === 'HEADPHONES'"
        class="picture"
        [alt]="product?.model"
        [src]="images.audio" />
      <img
        *ngIf="product?.category === 'TABLET'"
        class="picture"
        [alt]="product?.model"
        [src]="images.tablet" />
      <img
        *ngIf="product?.category === 'ACCESSORIES'"
        class="picture"
        [alt]="product?.model"
        [src]="images.accessory" />
      <img
        *ngIf="product?.category === 'LAPTOP'"
        class="picture"
        [alt]="product?.model"
        [src]="images.laptop" />
      <img
        *ngIf="product?.category === 'WATCH'"
        class="picture"
        [alt]="product?.model"
        [src]="images.watch" />
      <img
        *ngIf="product?.category === 'GAMING'"
        class="picture"
        [alt]="product?.model"
        [src]="images.gaming" />
    </span>
    <span class="fixed-space-8" aria-hidden="true"></span>
    <span class="head-wrapper">
      <span class="discount flex flex-col justify-center align-center">
        <h3 class="model flex justify-center">
          {{ t('category_' + (parsedCategory?.toLowerCase() || '') + '_title') }}
        </h3>

        <!--   <span>
          {{ t('price_banner_from') }}
          <b>{{ product?.price | amount }}</b>
          <span
            [innerHTML]="
              t('price_banner_or', { var1: product?.price | installmentAmount })
            "></span>
        </span>

        <span class="fixed-space-16" aria-hidden="true"></span> -->
      </span>
    </span>
  </a>
</ng-container>
